const FORECAST_YEARS = 6;
const HOURS_IN_DAY = 24;
const YEARLY_OUTLOOK_YEARS = 11;

const TIMEZONE_OPTIONS = [
  -720,
  -660,
  -600,
  -540,
  -480,
  -420,
  -360,
  -300,
  -240,
  -210,
  -180,
  -120,
  -60,
  0,
  60,
  120,
  180,
  210,
  240,
  270,
  300,
  330,
  360,
  390,
  420,
  480,
  510,
  540,
  570,
  600,
  630,
  660,
  720,
  780,
  840
];

export { FORECAST_YEARS, HOURS_IN_DAY, YEARLY_OUTLOOK_YEARS, TIMEZONE_OPTIONS };
